query Settings($companyId: String) {
  settings(companyId: $companyId) {
    company {
      isPhoneOptional
      isFirstNameOptional
      enabledFirstNameVerification {
        VALUATION
      }
      isLastNameOptional
      enabledLastNameVerification {
        VALUATION
      }
      isMotivationOptional
      enabledMotivationVerification {
        VALUATION
      }
      googleReviewLink
      enabledPhoneVerification {
        VALUATION
      }
      plotValuation {
        showInPropertyValuation
      }
    }
    lead {
      postalShipping {
        type
        allGuides
        activeLandingpages
      }
    }
  }
}
